


























































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class NotifList extends Vue {
  @Prop(Array) readonly items!: Array<any>;
}
